import { Grid } from '@mui/material';
import React from 'react';
import TestCasesTabContentComponent from '../../components/project-dashboard/test-cases/TestCasesTabContent';
import DashboardLayout from '../../layout/dashboard/DashboardLayout';

const TestCasesPage = () => {
  return (
    <DashboardLayout>
      <Grid container spacing={2}>
        <Grid item md={12}>
          <TestCasesTabContentComponent />
        </Grid>
      </Grid>
    </DashboardLayout>
  );
};

export default TestCasesPage;
